<div class="page-wrapper section-hr-direct">
    <app-left-menu [showMenu]="false"></app-left-menu>
    <div id="main-container">
        <app-header [showHistoryButton]="true" [title]="title"></app-header>
        <div class="content-header"> </div>
        <div class="page-content settings">
            <div class="no-absolute m-t30">

                <form [formGroup]="counselorForm">
                    <label>{{'Common.FirstName' | translate}}<span class="required">*</span></label>
                
                    <input type="text"  maxlength="256" formControlName="FirstName">
                    <label>{{'Common.LastName' | translate}}<span class="required">*</span></label>
                
                    <input type="text" maxlength="256" formControlName="LastName">
                  
                    <label style="display: block;">{{'Counselor.Label.License' | translate}}<span class="required">*</span></label>
                
                    <div *ngFor="let licenses of licenses;"  class="col-md-4">
                        <label>
                          <input  type="checkbox" [checked]="licenses.IsSelected" [value]="licenses.Id" (change)="onCheckChange($event)"/>
                          {{licenses.Name}}
                        </label>
                      </div>

                    <div>
                        <span class="error-message" *ngIf="error"> {{error}}</span>

                        <div>
                            <input type="submit" id="login" (click)="AddCounselor(counselorForm.value)"
                                [disabled]="!counselorForm.valid" class="btn btn-main"
                                value="{{'Common.Save' | translate}}" />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>